// removed by extract-text-webpack-plugin
module.exports = {"animated":"_2vsE-"};